import { createSelector } from '@reduxjs/toolkit';

export const selectUiState = (state) => state?.uiState;
export const selectFetchingModal = (state) => state?.uiState.isFetchingModal;
export const selectDisplaySkeleton = (state) => state?.uiState?.displayCardGridSkeleton;
export const selectPageLayout = (state) => state?.uiState?.pageLayout;
export const selectResultsPresentationType = (state) => state?.uiState?.resultsPresentationType;
export const selectModal = (state) => state?.uiState?.modalInformation;
export const selectDrawer = (state) => state?.uiState?.drawerInformation;
export const selectModalListingInformation = (state) => state?.uiState?.modalInformation?.listingInformation;
export const selectLoading = (state) => state?.configuration?.loading;
export const selectConfigurationResourceDomain = (state) => state?.configuration?.resourceDomain;
export const selectConfigurationSegmentApiKey = (state) => state?.configuration?.segmentApiKey;
export const selectConfigurationImageResizeService = (state) => state?.configuration?.imageResizeService;
export const selectConfigurationGoogleOneTapClientId = (state) => state?.configuration?.googleOneTapClientId;
export const selectIsMarkerAutoScrollFeatureEnabled = (state) => state?.configuration?.isMarkerAutoScrollFeatureEnabled;
export const selectLayoutBreakpoint = (state) => state?.uiState?.layoutBreakpoint;
export const selectConfigurationReCaptchaSiteKey = (state) => state?.configuration?.reCaptchaSiteKey;
export const selectConfigurationVwoSdkKey = (state) => state?.configuration?.vwoSdkKey;
export const selectConfigurationVwoAccountId = (state) => state?.configuration?.vwoAccountId;

/**
 * Selector to get all the host name used in NewHomeSource site.
 */
export const selectResourcesHostNames = createSelector(
  selectConfigurationResourceDomain,
  selectConfigurationImageResizeService,
  (resourceDomain, imageResizeService) => ({
    staticImagesHostName: resourceDomain,
    imageResizeService,
  })
);